import styled from "styled-components";
import { Tabs, Typography, Collapse } from "antd";

const { Paragraph } = Typography;
const { Panel } = Collapse;

export const StyledTabs = styled(Tabs)`
  display: flex;
  padding: 1%;
`;

export const StyledCollapse = styled(Collapse)`
  background-color: var(--neutral);
`;

export const StyledPanel = styled(Panel)`
  padding-bottom: 0.5%;
  background-color: var(--neutral);
`;

export const StyledParagraph = styled(Paragraph)`
  font-weight: normal;
  padding-left: 4.5%;
`;
